/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { serviceAccountsControllerCreateKey } from "./serviceAccountsControllerCreateKey";
import { serviceAccountsControllerDeleteAllKeys } from "./serviceAccountsControllerDeleteAllKeys";
import { serviceAccountsControllerDeleteKey } from "./serviceAccountsControllerDeleteKey";
import { serviceAccountsControllerGetApiSettings } from "./serviceAccountsControllerGetApiSettings";
import { serviceAccountsControllerListKeys } from "./serviceAccountsControllerListKeys";
import { serviceAccountsControllerUpdateApiSettings } from "./serviceAccountsControllerUpdateApiSettings";

export function serviceAccountsService() {
  return { serviceAccountsControllerListKeys, serviceAccountsControllerCreateKey, serviceAccountsControllerDeleteAllKeys, serviceAccountsControllerDeleteKey, serviceAccountsControllerGetApiSettings, serviceAccountsControllerUpdateApiSettings }
}